import styled from 'styled-components';

export const ChartStyles = styled.div`
  position: relative;
  padding: 16px 20px 28px;
  color: #16343a;
  background: #ffffff;
  font-family: 'SBS Sans', sans-serif;

  .chart-group + .chart-group {
    margin-top: 20px;
  }

  .chart-group-title {
    margin: 0 0 8px;
    color: #0d5b63;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.2;
  }

  .chart-columns {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
    gap: 20px;
    padding: 0 0 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid rgba(22, 52, 58, 0.16);
  }

  .chart-column-heading {
    color: #0d5b63;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .chart-column-heading-right {
    text-align: left;
    display: grid;
    gap: 8px;
  }

  .chart-bar-headings {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 10px;
    color: #54747a;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: normal;
    text-transform: none;
  }

  .chart-bar-heading {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .chart-bar-heading-unsustainable {
    justify-self: start;
  }

  .chart-bar-heading-sustainable {
    justify-self: end;
  }

  .chart-bar-heading::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
  }

  .chart-bar-heading-unsustainable::before {
    background: #d97706;
  }

  .chart-bar-heading-sustainable::before {
    background: #2f6bff;
  }

  .chart-rows {
    display: grid;
    gap: 6px;
  }

  .chart-row {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
    gap: 20px;
    align-items: center;
    padding: 3px 8px;
    margin: 0 -8px;
    border-radius: 8px;
    transition: background-color 120ms ease;
    cursor: pointer;
  }

  .chart-row.is-active {
    background: rgba(42, 167, 201, 0.1);
  }

  .chart-area {
    display: grid;
    gap: 2px;
  }

  .chart-area-name {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.15;
  }

  .chart-area-code {
    color: #6a858a;
    font-size: 12px;
    line-height: 1.2;
  }

  .chart-bar-side {
    display: grid;
    gap: 4px;
  }

  .chart-bar-line {
    display: grid;
    grid-template-columns: 4.8ch minmax(0, 1fr) 4.8ch;
    align-items: center;
    gap: 8px;
  }

  .chart-bar-wrap {
    display: flex;
    height: 12px;
    overflow: hidden;
    border-radius: 999px;
    background: rgba(22, 52, 58, 0.1);
    box-shadow: inset 0 0 0 1px rgba(22, 52, 58, 0.06);
  }

  .chart-bar {
    height: 100%;
  }

  .chart-bar-unsustainable {
    background: #d97706;
  }

  .chart-bar-sustainable {
    background: #2f6bff;
  }

  .chart-bar-pct {
    font-size: 11px;
    line-height: 1.1;
    font-weight: 600;
    white-space: nowrap;
  }

  .chart-bar-pct-unsustainable {
    color: #d97706;
    text-align: right;
  }

  .chart-bar-pct-sustainable {
    color: #2f6bff;
    text-align: left;
  }

  @media (max-width: 600px) {
    padding: 14px 16px 24px;

    .chart-group + .chart-group {
      margin-top: 18px;
    }

    .chart-group-title {
      font-size: 14px;
      margin-bottom: 8px;
    }

    .chart-columns {
      grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
      gap: 12px;
      padding-bottom: 6px;
      margin-bottom: 8px;
    }

    .chart-bar-headings {
      gap: 6px;
      font-size: 10px;
    }

    .chart-row {
      grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
      gap: 12px;
      padding: 2px 6px;
      margin: 0 -6px;
    }

    .chart-area-name {
      font-size: 13px;
      line-height: 1.15;
      font-stretch: condensed;
    }

    .chart-bar-line {
      grid-template-columns: 4.8ch minmax(0, 1fr) 4.8ch;
      gap: 6px;
    }

    .chart-bar-wrap {
      height: 10px;
    }

    .chart-bar-pct {
      font-size: 10px;
    }
  }
`;
